import React from 'react';
import PropTypes from 'prop-types';

const TabNavigation = ({
  tabs, activeType, onClick, itemStyle
}) => {
  return (
    <div className="flex flex-row h-max">
      {tabs.map(({ title, type }) => (
        <div
          key={type}
          role="presentation"
          onClick={() => onClick(type)}
          className={`
            cursor-pointer py-[16px] border-b border-transparent mr-[30px] transition-all duration-300 ease-out
            ${itemStyle || ''}
            ${activeType === type ? 'border-b-2 border-primary' : ''}
            hover:border-b-2 hover:border-primary
          `}
        >
          <span className={`${activeType === type ? 'text-primary' 
            : 'text-[#A1A5B7] dark:text-text-muted'} text-[14px] font-semibold`}
          >
            {title}
          </span>
        </div>
      ))}
    </div>
  );
};

TabNavigation.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    type: PropTypes.string
  })).isRequired,
  activeType: PropTypes.string,
  onClick: PropTypes.func,
  itemStyle: PropTypes.string
};

TabNavigation.defaultProps = {
  activeType: '',
  onClick: () => {},
  itemStyle: undefined
};

export default TabNavigation;
